export default function IconBtn({
    text,
    onclick,
    children,
    disabled,
    outline = false,
    customClasses,
    type,
  }) {
    return (
      <button
        disabled={disabled}
        onClick={onclick}
        className={`flex items-center ${
          outline ? "border border-[#f3f6e7] bg-transparent" : "bg-[#7e6fcd]"
        } cursor-pointer gap-x-2 rounded-md py-2 px-5 font-semibold text-[#f3f6e7] ${customClasses}`}
        type={type}
      >
        {children ? (
          <>
            <span className={`${outline && "text-[#7e6fcd]"}`}>{text}</span>
            {children}
          </>
        ) : (
          text
        )}
      </button>
    )
  }